import { CSSProperties } from 'react';

export const actionGridContainerStyle: CSSProperties = {
    maxWidth: '95%',
};
